var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchPost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-circle": "stroke",
    cx: 4.2,
    cy: 4.2,
    r: 3.2,
    stroke: "#1D1D46"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-path": "stroke",
    d: "M8.9999 8.9999L7.3999 7.3999",
    stroke: "#1D1D46",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchPost);
export default __webpack_public_path__ + "static/media/search-post.c3dd9ce58e33cc1f23f4fb11d3d5164d.svg";
export { ForwardRef as ReactComponent };